// extracted by mini-css-extract-plugin
module.exports = {"vUiHueLighter":"#fafafa","wrapper":"SplashScreen__wrapper___n7yLH","children":"SplashScreen__children___J7Gjc"};